import React, { ChangeEvent, FC } from "react";
import { useTranslation } from "react-i18next";
import { InputAdornment, TextField } from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import accountIcon from "@iconify/icons-mdi/account-network";
import { InlineIcon } from "@iconify/react";

export interface OcUsernameInputFieldProps {
  /** Current input value */
  value: string;
  /** Setter for input value */
  setValue: (value: string) => void;
  /** Whether the field is in error state */
  error: boolean;
  /** Setter for error state */
  setError: (error: boolean) => void;
  /** Helper text shown when in error */
  helperText: string;
  /** Setter for helper text */
  setHelperText: (text: string) => void;
}

export const OcUsernameInputField: FC<OcUsernameInputFieldProps> = ({
  value,
  setValue,
  error,
  setError,
  helperText,
  setHelperText,
}) => {
  const { t } = useTranslation();
  const theme: Theme = useTheme();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const handleFocus = () => {
    setError(false);
    setHelperText("");
  };

  return (
    <TextField
      id="oc-username-input-field"
      label={t("MY_HR_USERNAME")}
      variant="outlined"
      fullWidth
      value={value}
      onChange={handleChange}
      error={error}
      helperText={error ? helperText : undefined}
      onFocus={handleFocus}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <InlineIcon
              icon={accountIcon}
              height="24px"
              width="24px"
              color={theme.palette.gray60.main}
            />
          </InputAdornment>
        ),
      }}
    />
  );
};

OcUsernameInputField.displayName = "OcUsernameInputField";

export default OcUsernameInputField;
